import { RFC1918_RANGES } from 'app/util/constants';
import { isInSubnet } from 'core/util/ip';

function fn(value) {
  if (value) {
    return RFC1918_RANGES.filter((range) => isInSubnet(value, range)).length === 0;
  }

  return true;
}

export default {
  message:
    "RFC1918 IPs are not accessible from Kentik's platform, and will degrade query performance. Please remove the RFC1918 address, i.e. CIDR blocks '10.0.0.0/8', '172.16.0.0/12', and '192.168.0.0/16'",
  fn
};
